import React from 'react';

export default function PulseSpinner(props)
{
    return (
        <div className="animated fadeIn pt-1 text-center">
            <div className="sk-spinner sk-spinner-pulse" />
        </div>);
}